export const aos_btn_color = () => {
  const order_btn = document.querySelector('.buy-btn');

  // detect aos event
  document.addEventListener('aos:in', ({detail}) => {
    const {aosId, btnClass} = detail.dataset;
    if (aosId !== 'clear_btn') {
      order_btn.classList = `buy-btn ${btnClass}`;
    }
  });
  document.addEventListener('aos:out', ({detail}) => {
    const {aosId} = detail.dataset;
    console.log(aosId)
    if (aosId === 'clear_btn') {
      order_btn.classList = `buy-btn`;
    }
  });
}
